import React, { useEffect, useState } from 'react';
import ReactStrapTable from 'components/reactStrapTable';
import CellOptions from 'components/reactStrapTable/components/CellOptions';
import { cellRendererCheck, dateFormate } from 'utils/columns';
import NotificationHistory from '../NotificationHistory';
import { Button, FormGroup, Input, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import HoverImage from 'react-hover-image/build';
import historyIcon from 'assets/icon/icon-icon-options-history.svg';
import historyIconHover from 'assets/icon/icon-icon-options-history_hover.svg';
import plusIcon from 'assets/icon/Add.svg';
import collapse from 'assets/icon/collapse-icon.svg';
import collapseclose from 'assets/icon/collapse-icon-close.svg';
import useAxios from 'hooks/useAxios';
import { toast } from 'react-toastify';
import Loader from 'components/Loader';

const EMAIL_REGEX = /^[a-zA-Z][a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|in|us|io|ai|app|co|info)$/;

const NOTIFICATION_REPORT_TYPE_IDS = [
    'OFNzN0lSaS9pK2FzKzRSdzRaM29ZUT09',
    'cEJmc25WQm82QUNCLy85blNIWCtmQT09',
    "ejkwVkJObUJzbEM4WDRPRGhBK3FkUT09",
    "WWdDbzZzMXNHaGVMS3JtNEMva1ZBdz09",
    "Z3NpVnN5dTZwZ0dIK0s5dnRVL2V3QT09",
     "TTJxYWR5MVAxYVlJMEFweldSWTJtUT09",
    "TjFhcjBqc3FkaHNkTTg4K2ZyZFFidz09",
    "eTJiejRmeHFVMndlOUhpVVNBc2tWQT09"
];

let tableDataBackup = [];
let rowForEdit = {};

const ManageNotifications = ({ data, manval, collapseSider, onSearch, filters, applicationId, encryptedCEID, searchReportTypeId, fetchNotificationData, loading }) => {


    const API = useAxios();

    const [tableData, setTableData] = useState([]);
    const [reportTypes, setReportTypes] = useState([]);
    const [showHistory, setShowHistory] = useState(false);
    const [historyRow, setHistoryRow] = useState(null);
    const [fileTypes, setFileTypes] = useState([]);
    const [fileTypeid, setFileTypeid] = useState('');
    const [reportid, setReportid] = useState('');
    const [isChecked, setIsChecked] = useState(true);
    const [description, setDescription] = useState('');
    const [configuredEmails, setConfiguredEmails] = useState('');
    const [emailError, setEmailError] = useState('');
    const [editEmailError, setEditEmailError] = useState('');
    const [error, setError] = useState(false);
    const [addDisable, setAddDisable] = useState(false);
    const [saveDisabled, setSaveDisabled] = useState(false);

    const { profile } = JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const { sub } = profile || {};

const getEmailAddress = (item) => (
    typeof item === 'string' ? item : item?.configuredEmails || ''
);

const getActiveConfiguredEmails = (configuredEmails = []) => (
    configuredEmails.filter((item) => {
        if (typeof item === 'string') {
            return Boolean(item);
        }
        return item?.inactiveFlag !== 'Y' && Boolean(item?.configuredEmails);
    })
);

const getEmailStringsFromConfiguredEmails = (configuredEmails = []) => (
    getActiveConfiguredEmails(configuredEmails)
        .map(getEmailAddress)
        .filter(Boolean)
);

const formatConfiguredEmailsInput = (configuredEmails = []) => (
    getEmailStringsFromConfiguredEmails(configuredEmails).join(', ')
);

const buildConfiguredEmailObject = ({
    encryptedNotificationCenterID = '',
    encryptedConfiguredEmailsID = '',
    configuredEmails,
    inactiveFlag = '',
    modifiedByID,
    modifiedDate = '',
}) => ({
    encryptedNotificationCenterID,
    encryptedConfiguredEmailsID,
    configuredEmails,
    inactiveFlag,
    modifiedByID,
    modifiedDate,
});

const parseEmails = (value) => (
    (value || '')
        .split(',')
        .map((email) => email.trim())
        .filter(Boolean)
);

const parseEmailSlots = (value) => {
    if (value == null || String(value).trim() === '') {
        return [];
    }
    return String(value)
        .split(',')
        .map((email) => email.trim());
};

const getEmailParts = (email) => {
    const normalized = (getEmailAddress(email) || email || '').toLowerCase().trim();
    const parts = normalized.split('@');

    if (parts.length !== 2 || !parts[0] || !parts[1]) {
        return null;
    }

    return { local: parts[0], domain: parts[1] };
};

/**
 * Modified (no full clear): kept domain/TLD or kept local part.
 * New: original was fully cleared first (select-all OR backspace to empty).
 */
const isPartialEmailEdit = (originalEmail, editedEmail) => {
    const orig = getEmailParts(originalEmail);
    const edit = getEmailParts(editedEmail);

    if (!orig || !edit) {
        return false;
    }

    return orig.domain === edit.domain || orig.local === edit.local;
};

/** Domain still present in the slot (e.g. "@gmail.com" or "abd@gmail.com") */
const slotKeepsOriginalDomain = (originalEmail, slotValue) => {
    const orig = getEmailParts(originalEmail);
    if (!orig || !slotValue) {
        return false;
    }
    const slot = slotValue.toLowerCase();
    const domainToken = `@${orig.domain}`;
    return slot === domainToken || slot.endsWith(domainToken);
};

const getNonEmptySlotOriginalIndexes = (slots = [], slotOriginalIndexes = []) => (
    slots.reduce((acc, slot, index) => {
        if (slot) {
            acc.push(slotOriginalIndexes[index] ?? null);
        }
        return acc;
    }, [])
);

/**
 * Track which original email each slot belongs to.
 * Backspace leftovers (e.g. "a", "@gmail.com") still keep original index,
 * so clearing the slot marks the correct email as removed.
 */
const syncEmailEditState = (
    configuredEmailsOriginal,
    inputValue,
    emailSlotsSnapshot,
    fullyRemovedOriginalIndexes,
    emailSlotOriginalIndexes,
) => {
    const originals = getActiveConfiguredEmails(configuredEmailsOriginal);
    const originalStrings = originals.map(getEmailAddress);
    const previousSlots = emailSlotsSnapshot ?? originalStrings;
    const previousIndexes = emailSlotOriginalIndexes
        ?? previousSlots.map((_, index) => (index < originalStrings.length ? index : null));
    const currentSlots = parseEmailSlots(inputValue);
    const fullyRemoved = new Set(fullyRemovedOriginalIndexes || []);
    const newIndexes = [];

    const markRemoved = (originalIndex) => {
        if (originalIndex != null && originalIndex >= 0) {
            fullyRemoved.add(originalIndex);
        }
    };

    if (currentSlots.length === 0) {
        previousSlots.forEach((slot, index) => {
            if (slot) {
                markRemoved(previousIndexes[index]);
            }
        });
    } else {
        let previousIndex = 0;
        let currentIndex = 0;

        while (previousIndex < previousSlots.length || currentIndex < currentSlots.length) {
            if (currentIndex >= currentSlots.length) {
                if (previousSlots[previousIndex]) {
                    markRemoved(previousIndexes[previousIndex]);
                }
                previousIndex += 1;
                continue;
            }

            if (previousIndex >= previousSlots.length) {
                newIndexes.push(null);
                currentIndex += 1;
                continue;
            }

            const prevSlot = previousSlots[previousIndex];
            const currSlot = currentSlots[currentIndex];
            const prevOrigIdx = previousIndexes[previousIndex];

            if (!prevSlot && !currSlot) {
                newIndexes.push(null);
                previousIndex += 1;
                currentIndex += 1;
                continue;
            }

            // Slot emptied completely (no domain left) → fully removed
            if (prevSlot && !currSlot) {
                markRemoved(prevOrigIdx);
                newIndexes.push(null);
                previousIndex += 1;
                currentIndex += 1;
                continue;
            }

            if (!prevSlot && currSlot) {
                newIndexes.push(null);
                previousIndex += 1;
                currentIndex += 1;
                continue;
            }

            if (prevSlot.toLowerCase() === currSlot.toLowerCase()) {
                newIndexes.push(prevOrigIdx);
                previousIndex += 1;
                currentIndex += 1;
                continue;
            }

            // Current value matches a later previous slot → emails before it were removed
            const laterMatch = previousSlots.findIndex(
                (slot, idx) => idx > previousIndex
                    && Boolean(slot)
                    && slot.toLowerCase() === currSlot.toLowerCase()
            );
            if (laterMatch !== -1) {
                for (let i = previousIndex; i < laterMatch; i += 1) {
                    if (previousSlots[i]) {
                        markRemoved(previousIndexes[i]);
                    }
                }
                newIndexes.push(previousIndexes[laterMatch]);
                previousIndex = laterMatch + 1;
                currentIndex += 1;
                continue;
            }

            // In-place edit (e.g. backspace only "abc", keep "@gmail.com") – keep mapping
            newIndexes.push(prevOrigIdx);
            previousIndex += 1;
            currentIndex += 1;
        }
    }

    // Exact original typed back → restore that email
    currentSlots.forEach((slot, slotIndex) => {
        if (!slot) {
            return;
        }
        const exactOriginalIndex = originalStrings.findIndex(
            (item) => item.toLowerCase() === slot.toLowerCase()
        );
        if (exactOriginalIndex !== -1) {
            fullyRemoved.delete(exactOriginalIndex);
            newIndexes[slotIndex] = exactOriginalIndex;
        }
    });

    // Keep as edit when domain leftover/same domain (@gmail.com) and that original was not fully cleared
    currentSlots.forEach((slot, slotIndex) => {
        if (!slot) {
            return;
        }
        if (newIndexes[slotIndex] != null && !fullyRemoved.has(newIndexes[slotIndex])) {
            return;
        }

        const candidateIndex = previousIndexes[slotIndex];
        if (
            candidateIndex != null
            && !fullyRemoved.has(candidateIndex)
            && originalStrings[candidateIndex]
            && slotKeepsOriginalDomain(originalStrings[candidateIndex], slot)
        ) {
            newIndexes[slotIndex] = candidateIndex;
        }
    });

    const currentStrings = currentSlots.filter(Boolean);
    const locallyRemovedEmails = [...fullyRemoved]
        .filter((index) => originals[index])
        .map((index) => ({
            ...originals[index],
            inactiveFlag: 'Y',
        }));

    return {
        emailSlotsSnapshot: currentSlots,
        emailSlotOriginalIndexes: newIndexes,
        parsedEmailsSnapshot: currentStrings,
        fullyRemovedOriginalIndexes: [...fullyRemoved],
        locallyRemovedEmails,
    };
};

const buildEditEmailPayload = (
    originalEmails,
    editedEmails,
    notificationCenterId,
    modifiedByID,
    fullyRemovedOriginalIndexes = new Set(),
    editedSlotOriginalIndexes = [],
) => {
    const now = new Date().toISOString();
    const originals = getActiveConfiguredEmails(originalEmails);
    const editedToOriginal = new Map();
    const matchedOriginalIndexes = new Set();

    const buildUpdateEntry = (original, emailText) => buildConfiguredEmailObject({
        encryptedNotificationCenterID: original.encryptedNotificationCenterID || notificationCenterId,
        encryptedConfiguredEmailsID: original.encryptedConfiguredEmailsID || '',
        configuredEmails: emailText,
        inactiveFlag: '',
        modifiedByID,
        modifiedDate: now,
    });

    const buildNewEntry = (emailText) => buildConfiguredEmailObject({
        encryptedNotificationCenterID: notificationCenterId,
        configuredEmails: emailText,
        inactiveFlag: '',
        modifiedByID,
        modifiedDate: now,
    });

    const buildRemoveEntry = (original) => buildConfiguredEmailObject({
        encryptedNotificationCenterID: original.encryptedNotificationCenterID || notificationCenterId,
        encryptedConfiguredEmailsID: original.encryptedConfiguredEmailsID || '',
        configuredEmails: getEmailAddress(original),
        inactiveFlag: 'Y',
        modifiedByID,
        modifiedDate: now,
    });

    // Pass 1: unchanged emails – exact text match
    editedEmails.forEach((emailText, editedIndex) => {
        const normalized = emailText.toLowerCase();
        const originalIndex = originals.findIndex(
            (item, index) => !matchedOriginalIndexes.has(index)
                && getEmailAddress(item).toLowerCase() === normalized
        );
        if (originalIndex !== -1) {
            editedToOriginal.set(editedIndex, originalIndex);
            matchedOriginalIndexes.add(originalIndex);
        }
    });

    // Pass 2: use tracked slot → original index from editing
    editedEmails.forEach((emailText, editedIndex) => {
        if (editedToOriginal.has(editedIndex)) {
            return;
        }

        const mappedIndex = editedSlotOriginalIndexes[editedIndex];
        if (
            mappedIndex != null
            && !matchedOriginalIndexes.has(mappedIndex)
            && !fullyRemovedOriginalIndexes.has(mappedIndex)
            && originals[mappedIndex]
            && isPartialEmailEdit(getEmailAddress(originals[mappedIndex]), emailText)
        ) {
            editedToOriginal.set(editedIndex, mappedIndex);
            matchedOriginalIndexes.add(mappedIndex);
        }
    });

    // Pass 3: same domain/local → update, unless that original was fully cleared
    editedEmails.forEach((emailText, editedIndex) => {
        if (editedToOriginal.has(editedIndex)) {
            return;
        }

        const mappedIndex = editedSlotOriginalIndexes[editedIndex];
        if (mappedIndex != null && fullyRemovedOriginalIndexes.has(mappedIndex)) {
            return;
        }

        const originalIndex = originals.findIndex(
            (item, index) => !matchedOriginalIndexes.has(index)
                && !fullyRemovedOriginalIndexes.has(index)
                && isPartialEmailEdit(getEmailAddress(item), emailText)
        );

        if (originalIndex !== -1) {
            editedToOriginal.set(editedIndex, originalIndex);
            matchedOriginalIndexes.add(originalIndex);
        }
    });

    const updatedAndNew = editedEmails.map((emailText, editedIndex) => {
        const originalIndex = editedToOriginal.get(editedIndex);
        if (originalIndex !== undefined) {
            return buildUpdateEntry(originals[originalIndex], emailText);
        }
        return buildNewEntry(emailText);
    });

    const removed = originals
        .filter((_, index) => !matchedOriginalIndexes.has(index))
        .map(buildRemoveEntry);

    return [...updatedAndNew, ...removed];
};

const getUniqueEmails = (emails) => {
    const seen = new Set();
    return emails.filter((email) => {
        const normalized = email.toLowerCase();
        if (seen.has(normalized)) {
            return false;
        }
        seen.add(normalized);
        return true;
    });
};

const getNormalizedEmailList = (emails) => (
    getUniqueEmails(
        Array.isArray(emails)
            ? emails.map(getEmailAddress)
            : parseEmails(emails)
    )
        .map((email) => email.toLowerCase())
        .sort()
);

const hasNotificationChanges = (row, editedEmails) => {
    const originalList = getNormalizedEmailList(row.configuredEmailsOriginal);
    const editedList = getNormalizedEmailList(editedEmails);
    const emailsChanged = originalList.join(',') !== editedList.join(',');
    const statusChanged = row.isActive !== row.originalIsActive;
    const hasLocallyRemoved = (row.fullyRemovedOriginalIndexes || []).length > 0;
    return emailsChanged || statusChanged || hasLocallyRemoved;
};

const validateEmails = (value) => {
    const emails = parseEmails(value);
    if (emails.length === 0) {
        return { valid: false, message: 'At least one email is required', emails: [] };
    }
    const invalidEmail = emails.find((email) => !EMAIL_REGEX.test(email));
    if (invalidEmail) {
        return { valid: false, message: `Invalid email: ${invalidEmail}`, emails: [] };
    }
    const uniqueEmails = getUniqueEmails(emails);
    if (uniqueEmails.length !== emails.length) {
        return { valid: false, message: 'Duplicate emails are not allowed', emails: [] };
    }
    return { valid: true, message: '', emails: uniqueEmails };
};

const Emaillist = (row) => {
    const displayLimit = 1;
    const emails = getActiveConfiguredEmails(row.configuredEmails);
    if (emails.length === 0) {
        return '-';
    }
    const displayedEmails = emails.slice(0, displayLimit);
    const hiddenEmails = emails.slice(displayLimit);
    return (
        <div>
            {displayedEmails.map((email, index) => (
                <Badge
                    key={index}
                    pill
                    bg="secondary"
                    style={{
                        marginRight: '8px',
                        padding: '10px',
                        color: '#555555',
                        margin: 'auto',
                        width: 'auto',
                    }}
                >
                    {getEmailAddress(email)}
                </Badge>
            ))}
            <div>
                {hiddenEmails.length > 0 && (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="configured-emails-tooltip">
                                <div style={{ textAlign: 'left' }}>
                                    {hiddenEmails.map((email) => getEmailAddress(email)).join(', ')}
                                </div>
                            </Tooltip>
                        }
                    >
                        <span style={{
                            color: '#702C62',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '500',
                            textDecoration: 'underline',
                        }}
                        >
                            +{hiddenEmails.length} More
                        </span>
                    </OverlayTrigger>
                )}
            </div>
        </div>
    );
};
    const hasSearch = Boolean(applicationId) && Boolean(
        Array.isArray(encryptedCEID) ? encryptedCEID.length : encryptedCEID
    );

    const newRowTemplate = {
        reportConfigID: '0',
        isNew: true,
        iaActive: 'N',
        claimType: '',
        claimTypeDesc: '',
        encryptedReportTypeID: '',
        reportTypeName: '',
        frequencyDesc: '',
        comments: '',
    };

    const displayData = hasSearch
        ? [newRowTemplate, ...tableData]
        : [];

    useEffect(() => {
        const rows = hasSearch ? (data || []) : [];
        tableDataBackup = rows;
        setTableData(rows);
        rowForEdit = {};
        setEditEmailError('');
    }, [data, encryptedCEID, applicationId]);

    useEffect (() =>{
        setConfiguredEmails('');
            setEmailError('');
            setDescription('');
            setFileTypeid('');
            setReportid('');
            setIsChecked(true);
            setError(false);
    },[encryptedCEID])

    useEffect(() => {
        fetchFileTypes();
    }, []);

    useEffect(() => {
        if (!applicationId) {
            setReportTypes([]);
            return;
        }
        fetchReportType(applicationId);
    }, [encryptedCEID, searchReportTypeId]);

    useEffect(() => {
        if (reportTypes?.length === 1) {
            setReportid(reportTypes[0].encryptedReportTypeID);
        } else {
            setReportid('');
        }
    }, [reportTypes]);

    const fetchReportType = async (appid) => {
        try {
            const { data: reportTypeData } = await API.get(`api/Report/types/${appid}`, {
                hasDefaultURL: true,
                hideLoader: true,
            });
            if (!reportTypeData) {
                setReportTypes([]);
                return;
            }

            let types = reportTypeData.filter((item) =>
                NOTIFICATION_REPORT_TYPE_IDS.includes(item.encryptedReportTypeID)
            );

            if (searchReportTypeId) {
                types = NOTIFICATION_REPORT_TYPE_IDS.includes(searchReportTypeId)
                    ? types.filter((item) => item.encryptedReportTypeID === searchReportTypeId)
                    : [];
            }

            setReportTypes(types);
        } catch (err) {
            'failed to load data';
        }
    };

    const fetchFileTypes = async () => {
        try {
            const { data: fileTypeData } = await API.get('api/Report/fileTypes', {
                hasDefaultURL: true,
                hideLoader: true,
            });
            if (fileTypeData) {
                setFileTypes(fileTypeData);
            } else {
                setFileTypes([]);
            }
        } catch (err) {
            'failed to load data';
        }
    };

    const updateRowValue = (value, col) => {
        if (col === 'configuredEmailsInput') {
            const emailEditState = syncEmailEditState(
                rowForEdit.configuredEmailsOriginal,
                value,
                rowForEdit.emailSlotsSnapshot,
                rowForEdit.fullyRemovedOriginalIndexes,
                rowForEdit.emailSlotOriginalIndexes,
            );
            rowForEdit = {
                ...rowForEdit,
                configuredEmailsInput: value,
                ...emailEditState,
            };
        } else {
            rowForEdit = { ...rowForEdit, [col]: value };
        }

        setTableData([...tableDataBackup]);

        if (col === 'configuredEmailsInput' && editEmailError) {
            setEditEmailError('');
        }
    };

    const editRow = (rowData, isEdit = true) => {
        setError(false);
        setEmailError('');
        setEditEmailError('');
        setSaveDisabled(false);
        if (!isEdit) {
            const restoredData = tableDataBackup.map((row) => {
                if (row.encryptedNotificationCenterID === rowData?.encryptedNotificationCenterID) {
                    const original = (data || []).find(
                        (item) => item.encryptedNotificationCenterID === row.encryptedNotificationCenterID
                    );
                    return original ? { ...original, isEdit: false } : { ...row, isEdit: false };
                }
                return { ...row, isEdit: false };
            });
            rowForEdit = {};
            tableDataBackup = restoredData;
            setTableData(restoredData);
            return;
        }

        const tempData = tableDataBackup.map((row) => {
            if (row.encryptedNotificationCenterID === rowData?.encryptedNotificationCenterID) {
                const originalEmailStrings = getEmailStringsFromConfiguredEmails(row.configuredEmails);
                rowForEdit = {
                    ...row,
                    configuredEmailsOriginal: row.configuredEmails || [],
                    configuredEmailsInput: formatConfiguredEmailsInput(row.configuredEmails),
                    originalIsActive: row.isActive,
                    emailSlotsSnapshot: originalEmailStrings,
                    emailSlotOriginalIndexes: originalEmailStrings.map((_, index) => index),
                    parsedEmailsSnapshot: originalEmailStrings,
                    fullyRemovedOriginalIndexes: [],
                    locallyRemovedEmails: [],
                };
                return { ...row, isEdit: true };
            }
            return { ...row, isEdit: false };
        });
        tableDataBackup = tempData;
        setTableData(tempData);
    };

    const saveUpdateRow = async () => {
        if (saveDisabled) {
            return;
        }
        const emailValidation = validateEmails(rowForEdit.configuredEmailsInput);
        if (!emailValidation.valid) {
            setEditEmailError(emailValidation.message);
            return;
        }
        setEditEmailError('');
        if (!hasNotificationChanges(rowForEdit, emailValidation.emails)) {
            toast.error('please edit Status or Email and then click on Save');
            return;
        }
        const rowEncryptedNotificationCenterID = rowForEdit.encryptedNotificationCenterID
            ?? getActiveConfiguredEmails(rowForEdit.configuredEmailsOriginal)[0]?.encryptedNotificationCenterID
            ?? '';
        const configuredEmails = buildEditEmailPayload(
            rowForEdit.configuredEmailsOriginal,
            emailValidation.emails,
            rowEncryptedNotificationCenterID,
            sub,
            new Set(rowForEdit.fullyRemovedOriginalIndexes || []),
            getNonEmptySlotOriginalIndexes(
                rowForEdit.emailSlotsSnapshot || [],
                rowForEdit.emailSlotOriginalIndexes || [],
            ),
        );
        const payload = {
            encryptedNotificationCenterID: rowForEdit.encryptedNotificationCenterID,
            encryptedApplicationTypeID: rowForEdit.encryptedApplicationTypeID || filters?.EncryptedApplicationId,
            encryptedCEID: rowForEdit.encryptedCEID || encryptedCEID,
            encryptedReportTypeID: rowForEdit.encryptedReportTypeID,
            encryptedFileTypeID: rowForEdit.encryptedFileTypeID,
            isActive: rowForEdit.isActive,
            description: rowForEdit.description,
            configuredEmails,
            modifiedByID: sub,
        };
        setSaveDisabled(true);
        try {
            await API.post('api/Report/editNotificationCenter', payload, {
                hasDefaultURL: true,
                hideLoader: true,
            });
            toast.success('Notification updated successfully');
            editRow(rowForEdit, false);
            // if (onSearch && filters) {
            //     onSearch(filters);
            // } else 
                if (fetchNotificationData && filters) {
                fetchNotificationData(filters);
            }
        } catch (err) {
            toast.error('Failed to update notification');
        } finally {
            setSaveDisabled(false);
        }
    };

    const handleToggle = () => {
        setIsChecked(!isChecked);
    };

    const handleResponse = (response) => {
        if (response.status === 201) {
            fetchNotificationData(filters);
            toast.success('Notification added successfully');
        } else {
            toast.error('Failed to add notification');
        }
    };

    const handleAdd = async () => {
        setAddDisable(true)
        const emailValidation = validateEmails(configuredEmails);
        const hasRequiredFields = fileTypeid !== '' && reportid !== '';
        if (!hasRequiredFields || !emailValidation.valid) {
            setError(true);
            setEmailError(emailValidation.valid ? '' : emailValidation.message);
            setAddDisable(false)
            return;
        }
        setError(false);
        setEmailError('');
        const payload = {
            encryptedNotificationCenterID: '',
            encryptedApplicationTypeID: filters?.EncryptedApplicationId,
            encryptedCEID: encryptedCEID,
            encryptedReportTypeID: reportid,
            isActive: isChecked ? 'Y' : 'N',
            encryptedFileTypeID: fileTypeid,
            description: description,
             configuredEmails: emailValidation.emails,
     modifiedByID: sub,
        };
        try {
            const response = await API.post('api/Report/addNotificationCenter', payload, {
                hasDefaultURL: true,
                hideLoader: true,
            });
            handleResponse(response);
        } catch (err) {
             if (err?.response?.status === 409) {
    toast.error('Notification details already exist')
  }
        }
        setConfiguredEmails('');
            setEmailError('');
            setDescription('');
            setFileTypeid('');
            setReportid(reportTypes?.length === 1? reportid :'');
            setIsChecked(true);
            setAddDisable(false)
    };

    const handleReportChange = (e) => {
        const { value } = e.target;
        setReportid(value || '');
    };

    const handleFileChange = (e) => {
        const { value } = e.target;
         setFileTypeid(value || '');
        if(value == "T2p3WWUrL1RsTkNKY2lXL09DS1JsQT09"){
            setDescription("When this feature is enabled, the system will automatically send an email notification to the pre‑configured email addresses once the files have been successfully generated.")
        }
        else if(value == "M2NPNFdFVXlYK2N5eEJkVXBDZ2Z5dz09"){
            setDescription("When this feature is enabled, the system will automatically send an email notification to the pre‑configured email addresses if an ESP response file is received.")
        }
    };


    const handleEmailChange = (e) => {
        setConfiguredEmails(e.target.value);
        if (emailError) {
            setEmailError('');
        }
    };

    const handleEmailBlur = () => {
        const uniqueEmails = getUniqueEmails(parseEmails(configuredEmails));
        if (uniqueEmails.length > 0) {
            setConfiguredEmails(uniqueEmails.join(', '));
        }
    };

    const handleEditEmailBlur = () => {
        const emails = parseEmails(rowForEdit.configuredEmailsInput);
        if (emails.length === 0) {
            return;
        }

        const invalidEmail = emails.find((email) => !EMAIL_REGEX.test(email));
        if (invalidEmail) {
            setEditEmailError(`Invalid email: ${invalidEmail}`);
            return;
        }

        const uniqueEmails = getUniqueEmails(emails);
        if (uniqueEmails.length !== emails.length) {
            setEditEmailError('Duplicate emails are not allowed');
            return;
        }

        setEditEmailError('');
        updateRowValue(uniqueEmails.join(', '), 'configuredEmailsInput');
    };

    const renderConfiguredEmails = (row, col) => {
        if (row.isNew) {
            return (
                <>
                    <Input
                        type='text'
                        className='iconremove'
                        value={configuredEmails}
                        onChange={handleEmailChange}
                        onBlur={handleEmailBlur}
                        autoComplete='off'
                    />
                    {emailError && <div className='text-danger f-12'>{emailError}</div>}
                </>
            );
        }
        if (row.isEdit) {
            return (
                <>
                    <Input
                        type='text'
                        className='iconremove'
                        value={rowForEdit.configuredEmailsInput || ''}
                        onChange={(e) => updateRowValue(e.target.value, 'configuredEmailsInput')}
                        onBlur={handleEditEmailBlur}
                        autoComplete='off'
                    />
                    {editEmailError && (
                        <div className='text-danger f-12'>{editEmailError}</div>
                    )}
                </>
            );
        }
        return Emaillist(row);
    };

    const renderReportType = () => (
        <>
            <Input
                type='select'
                value={reportid || ''}
                disabled={reportTypes?.length === 1}
                onChange={handleReportChange}
            >
                <option value=''>--select--</option>
                {reportTypes?.map((item) => (
                    <option key={item.encryptedReportTypeID} value={item.encryptedReportTypeID}>
                        {item.reportTypeName}
                    </option>
                ))}
            </Input>
            {(error) && (reportid === '' || reportid === undefined) && (
                <div className="text-danger f-12">Report Type is required</div>
            )}
        </>
    );

    const renderFileType = () => (
        <>
            <Input
                type='select'
                value={fileTypeid}
                onChange={handleFileChange}
            >
                <option value=''>--select--</option>
                {fileTypes?.map((item) => (
                    <option key={item.encryptedFileTypeId} value={item.encryptedFileTypeId}>
                        {item.fileTypeName}
                    </option>
                ))}
            </Input>
            {(error) && (fileTypeid === '' || fileTypeid === undefined) && (
                <div className="text-danger f-12">File Type is required</div>
            )}
        </>
    );

    const renderStatus = (row) => {
        if (row.isNew) {
            return (
                <FormGroup switch style={{ paddingRight: '15px' }} className='form-check form-switch re_con mb-0'>
                    <Input
                        className='form-check-input'
                        type="switch"
                        checked={isChecked}
                        onClick={handleToggle}
                    />
                </FormGroup>
            );
        }
        const statusValue = row.isEdit ? rowForEdit.isActive : row.isActive;
        return (
            <FormGroup switch style={{ paddingRight: '15px' }} className='form-check form-switch re_con mb-0'>
                <Input
                    className='form-check-input'
                    type="switch"
                    checked={statusValue === 'Y'}
                    onChange={row.isEdit
                        ? () => updateRowValue(rowForEdit.isActive === 'Y' ? 'N' : 'Y', 'isActive')
                        : undefined}
                    readOnly={!row.isEdit}
                />
            </FormGroup>
        );
    };

    const renderDescription = () => (
        <Input
            id='reportname'
             className='iconremove'
            name='reportname'
            type='text'
            value={description}
            autoComplete='off'
        />
    );
    

    const handleHistory =(row) =>{
        setHistoryRow(row.encryptedNotificationCenterID);
         setShowHistory(!showHistory);

    }
    const renderOptions = (row) => {
        if (row.isNew) {
            return (
                <Button className='text-primary p-0 text-decoration-none' color='link' disabled={addDisable} onClick={handleAdd} title='Add'>
                    <img src={plusIcon} alt='Add' />
                </Button>
            );
        }
        return (
            <div className='d-flex align-items-center'>
                <Button
                    className='icon text-primary p-0 text-decoration-none me-1'
                    color='link'
                    onClick={() => { handleHistory(row)}}
                    title='History'
                >
                    <HoverImage src={historyIcon} hoverSrc={historyIconHover} alt='' />
                </Button>
                <CellOptions row={row} onEdit={editRow} editTitle="Edit Notifications"
                 onSave={saveUpdateRow} saveTitle="Save Notifications" saveDisabled={saveDisabled} />
            </div>
        );
    };

    const columns = [
        {
            dataField: 'edit',
            text: 'Options',
            cellRenderer: renderOptions,
            width: 100,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
        {
            dataField: 'isActive',
            text: 'Status',
            width: 100,
            show: true,
            hideColFilter: true,
            edit: true,
            cellRenderer: (row) => renderStatus(row),
        },
        {
            dataField: 'encryptedFileTypeId',
            text: 'File Type',
            width: 160,
            show: true,
            hideColFilter: true,
            cellRenderer: (row) =>
                row.isNew ? renderFileType(row) : cellRendererCheck(row.fileTypeName),
        },
        {
            dataField: 'reportTypeName',
            text: 'Report Type',
            width: 180,
            show: true,
            hideColFilter: true,
            cellRenderer: (row) =>
                row.isNew ? renderReportType(row) : cellRendererCheck(row.reportTypeName),
        },
        {
            dataField: 'description',
            text: 'Description',
            width: 500,
            show: true,
            hideColFilter: true,
            cellRenderer: (row) =>
                row.isNew ? renderDescription(row) : cellRendererCheck(row.description),
        },
        {
            dataField: 'configuredEmailsInput',
            text: 'Configure Email IDs',
            width: 400,
            show: true,
            hideColFilter: true,
            edit: true,
            cellRenderer: (row, col) => renderConfiguredEmails(row, col),
        },
        {
            dataField: 'modifiedBy',
            text: 'Modified By',
            width: 200,
            show: true,
            hideColFilter: true,
            cellRenderer: (row) => (row.isNew ? '' : cellRendererCheck(row.modifiedBy)),
        },
        {
            dataField: 'modifiedDate',
            text: 'Modified Date',
            width: 140,
            show: true,
            hideColFilter: true,
            cellRenderer: (row) => (row.isNew ? '' : dateFormate(row.modifiedDate)),
        },
    ];

    return (
        <div>
            {loading && <Loader opacity={0.01} color='black' ConfigTable />}
            <div className='d-flex justify-content-between pb-2'>
                <h3 className='font-20'>Search Results</h3>
                <span style={{ cursor: 'pointer' }} onClick={() => manval()}>
                    <img src={!collapseSider ? collapse : collapseclose} alt='' />
                </span>
            </div>
            <div className='table-card scroll-table position-relative border-0 rounded pt-0'>
                <ReactStrapTable
                    id='notification-table'
                    height={550}
                    fixedColumn
                    width={1200}
                    data={displayData}
                    columns={columns}
                    hasDefaultPagination={false}
                />
            </div>
            
             <Modal
                isOpen={showHistory}
                toggle={handleHistory}
                centered={true}
                className="reportModal"
            
            >
                <ModalHeader className="modal-title">
                    <div className="title-cancel-icon">
                        <span>Modification History
                        </span>
                        <Button className="modal-title-close" onClick={handleHistory}>X</Button>
                    </div>
                </ModalHeader>
                <ModalBody className='pt-0'>
                    <NotificationHistory
                    notificationId={historyRow}
                     setShow={setShowHistory} show={showHistory}
                       />
                </ModalBody>


            </Modal>
           {/* {showHistory && <NotificationHistory notificationId={historyRow} setShow={setShowHistory} show={showHistory} />} */}
        </div>
    );
};

export default ManageNotifications;
